import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom'; // Importar Routes y Route
import './App.css';
import Navbar from './components/Navbar';
// import Hero from './components/Hero';
import Footer from './components/Footer';
// import Section from './components/Sections';
// import Article from './components/Article';
// import HeroSection from './components/HeroSection';
// import CallToAction from './components/CallToAction';
import Home from './pages/Home'; // Página principal
import PrivacyPolicy from './pages/PrivacyPolicies';
// import imageArticle1 from './assets/image/person-working-html-computer.jpg';
// import { LuShieldCheck, LuRocket, LuPiggyBank } from "react-icons/lu";

function App() {
  return (
    <BrowserRouter> {/* Envolver la aplicación en BrowserRouter */}
      <div className="App">
        <Navbar /> {/* Navbar visible en todas las páginas */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
        <Footer /> {/* Footer visible en todas las páginas */}
      </div>
    </BrowserRouter>
  );
}

export default App;
